<template>
  <b-field :label="label"
           :type="!!error? 'is-danger': ''"
           :message="error">
    <b-select :placeholder="placeholder"
              :value="value"
              @input="val => $emit('input', val)"
              expanded>
      <option v-for="item in countries"
              :value="item[primaryKey]">
        {{ item[optionText] }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "SelectCountry",
  props: {
    primaryKey: {
      type: String,
      default: 'code'
    },
    optionText: {
      type: String,
      default: 'name'
    },
    label: String,
    placeholder: String,
    value: {
      default: 'MX'
    },
    state: String | Number,
    error: {}
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState({
      countries: state => state.main.countries
    }),
  },
}
</script>

<style scoped>

</style>